export default "__VITE_ASSET__Dfqjfbvo__"